<template>
  <div class="about">
    <h1>A site to show how much I love the Annika ;)</h1>
  </div>
</template>
